import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {ClassroomVideoStore} from './ClassroomVideoStore';

@observer
export class RemoteVideo extends React.Component<{ store: ClassroomVideoStore }> {
  render() {
    const store = this.props.store;
    const stream = store.simplePeer?.remoteStream;

    console.log('REMOTE VIDEO STATE >>>>', store)

    const className = classNames('remote-video', {
      'has-video': stream !== null && stream !== undefined,
      'has-no-video': stream === null || stream === undefined
    });

    return (
      <div className={className} key="remote-video">
        <video className="remote-video"
               autoPlay playsInline
               ref={store.remoteVideoRef}/>
      </div>);
  }
}
